import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiBackOfficeGetForm(formId = '', type = 'TQ', language = 'EN') {
    return getFetch(`${API_SERVERLESS}/backOffice/v3/formWithQuestions/${language}/${type}/${formId}`, false);
}
